<div class="terms" *transloco="let t">
	<op-back-link *ngIf="showBackButton" class="op-mt-20" id="termsBck">{{ t('TERMS.back') }}</op-back-link>
	<op-masthead [title]="t('TERMS.title')"></op-masthead>
	<op-content-container class="content">
		<div [innerHTML]="t('TERMS.terms')"></div>
	</op-content-container>
</div>
